// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TMmv","colMin":"styles_colMin__18aKH"};